module.exports = __webpack_public_path__ + "static/img/think.87ae510.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/doubleDan/think.png
// module id = G2Vo
// module chunks = 1